import { render, staticRenderFns } from "./menu2_2.vue?vue&type=template&id=5509afb6&scoped=true&"
import script from "./menu2_2.vue?vue&type=script&lang=js&"
export * from "./menu2_2.vue?vue&type=script&lang=js&"
import style0 from "./menu2_2.vue?vue&type=style&index=0&id=5509afb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509afb6",
  null
  
)

export default component.exports